import { CommonService } from '@app/shared/services/common.service';
import { Component, OnInit, ViewChild, Renderer2, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DockerOption, FlightPlanTitles } from '../flight-plan-constant';
import { FlightPlanService } from './services/flight-plan.service';
import { NavigationService } from '@app/core/services/navigation-service.service';
import { EnterTripDetailsService } from '@app/trips/services/enter-trip-details.service';
import { MessageConfig } from '@app/shared/constants/constant';
import { ModalController, NavController } from '@ionic/angular';
import { Events } from '@app/shared/services/events.service';
import { UtilService } from '@app/core/services/util.service';
import { FlightPlanWarningsComponent } from '@app/flightplans/flight-plan-ui/flight-plan-warnings/flight-plan-warnings.component';
import { Storage } from '@ionic/storage-angular';
import { environment } from '@environment/environment';
import { Platform } from '@ionic/angular';

@Component({
    selector: 'app-route-plan',
    templateUrl: './route-plan.page.html',
    styleUrls: ['./route-plan.page.scss'],
    standalone: false
})
export class RoutePlanPage implements OnInit, OnDestroy {
  public dockerOption = new DockerOption();
  public flightPlanTitles = FlightPlanTitles;
  public title: string;
  public viewEdit = '0';
  public closeButton: string;
  public tripID: string;
  public legId: string;
  public hideCompute: string;
  public backPage: string;
  public showConfirm: any = false;
  public filePath: string;
  public sector: string;
  public vendorid: string;
  public customhContentHeight: boolean = false;
  public footerRelative: boolean = false;
  public drawerDefault: boolean = false;
  @ViewChild('drawer') public drawer: any;
  public drawerState: any;
  public selectedRoute:any;
  private androidVersion: number;
  private cssClassListener: any;

  constructor(
    public flightPlanService: FlightPlanService,
    private activatedRoute: ActivatedRoute,
    public navigationService: NavigationService,
    public location: Location,
    private event: Events,
    private enterTripDetailsService: EnterTripDetailsService,
    private router: Router,
    private navCtrl: NavController,
    private events: Events,
    public utilService: UtilService,
    private modalCntrl: ModalController,
    private storage: Storage,
    private commonService: CommonService,
    private platform: Platform,
    private renderer: Renderer2
  ) {
    if (this.router.getCurrentNavigation().extras.state) {
      const params = this.router.getCurrentNavigation().extras.state;
      this.tripID = params?.tripID;
      this.closeButton = params?.showCloseButton;
      this.legId = params?.legId ? params?.legId : undefined;
      this.hideCompute = params?.hideCompute;
      this.backPage = params?.backPage;
      this.showConfirm = params?.showConfirm ? params?.showConfirm : false;
      this.filePath = params?.filePath;
      this.sector = params?.sector;
      this.vendorid = params?.VendorID ? params?.VendorID : params?.vendorid;
      this.selectedRoute = params?.selectedRoute;
    }
    this.detectAndroidVersion();
  }

  public ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.flightPlanService
        .getATCRouteByLegID(Number(params.get('id')))
        .then(() => {
          this.title =
            this.flightPlanService.tripRouteData.AircraftDetail.Registration +
            ' | ' +
            this.flightPlanService.tripRouteData.from +
            '-' +
            this.flightPlanService.tripRouteData.to;
        });
    });

    this.addPlatformClass();
  }

  public ngOnDestroy() {
    if (this.cssClassListener) {
      this.cssClassListener();
    }
    this.flightPlanService.toggleFlagToAuto = false;
  }

  private detectAndroidVersion() {
    if (this.platform.is('android')) {
      const userAgent = navigator.userAgent;
      const androidMatch = userAgent.match(/Android\s([0-9.]+)/);
      if (androidMatch && androidMatch[1]) {
        this.androidVersion = parseInt(androidMatch[1].split('.')[0], 10);
      }
    }
  }

  private addPlatformClass() {
    const htmlElement = document.querySelector('html');

    if (this.platform.is('ios')) {
      this.renderer.addClass(htmlElement, 'ios');
    } else if (this.platform.is('android')) {
      this.renderer.addClass(htmlElement, 'android');

      if (this.androidVersion === 13) {
        this.renderer.addClass(htmlElement, 'android-13');
      } else if (this.androidVersion === 14) {
        this.renderer.addClass(htmlElement, 'android-14');
      } else if (this.androidVersion === 15 || this.androidVersion === 16) {
        this.renderer.addClass(htmlElement, 'android-15-plus');
      }
    }
  }

  public ngAfterViewInit() {}
  // drawer states "0 means bottom"
  // drawer states "1 means docked"
  // drawer states "2 means top"
  public toggleDrawer(drawerState) {
    switch (drawerState) {
      case 0:
        this.dockerOption.drawerState = 2;
        break;
      case 1:
        this.dockerOption.drawerState = 2;
        if (
          this.flightPlanService.flightPlanningAccordionOpenStatus == 'payload'
        ) {
          this.flightPlanService.flightPlanningAccordionOpenStatus = undefined;
        }
        if (
          this.flightPlanService.flightPlanningAccordionOpenStatus ==
          'alternate'
        ) {
          this.flightPlanService.flightPlanningAccordionOpenStatus = undefined;
        }
        if (
          this.flightPlanService.flightPlanningAccordionOpenStatus ==
          'flightplanetop'
        ) {
          this.flightPlanService.flightPlanningAccordionOpenStatus = undefined;
        }
        if (
          this.flightPlanService.flightPlanningAccordionOpenStatus ==
          'flightdetails'
        ) {
          this.flightPlanService.flightPlanningAccordionOpenStatus = undefined;
        }
        if (
          this.flightPlanService.flightPlanningAccordionOpenStatus ==
          'destroute'
        ) {
          this.flightPlanService.flightPlanningAccordionOpenStatus = undefined;
        }
        if (
          this.flightPlanService.flightPlanningAccordionOpenStatus ==
          'flightplanfuel'
        ) {
          this.flightPlanService.flightPlanningAccordionOpenStatus = undefined;
        }
        if (
          this.flightPlanService.flightPlanningAccordionOpenStatus ==
          'flightplanavoid'
        ) {
          this.flightPlanService.flightPlanningAccordionOpenStatus = undefined;
        }
        break;
      case 2:
        this.dockerOption.drawerState = 1;
        if (
          this.flightPlanService.flightPlanningAccordionOpenStatus == 'payload'
        ) {
          this.flightPlanService.flightPlanningAccordionOpenStatus = undefined;
          this.events.subscribe('payloadOnInput', (payloadInput) => {
            if (payloadInput) {
              this.customhContentHeight = true;
            }
          });
          if (!this.flightPlanService.flightPlanningAccordionOpenStatus) {
            this.dockerOption.drawerState = 0;
          }
        }
        if (
          this.flightPlanService.flightPlanningAccordionOpenStatus ==
          'alternate'
        ) {
          this.flightPlanService.flightPlanningAccordionOpenStatus = undefined;
          this.events.subscribe('alternateOnInput', (payloadInput) => {
            if (payloadInput) {
              this.customhContentHeight = true;
            }
          });
          if (!this.flightPlanService.flightPlanningAccordionOpenStatus) {
            this.dockerOption.drawerState = 0;
          }
        }
        if (
          this.flightPlanService.flightPlanningAccordionOpenStatus ==
          'flightplanetop'
        ) {
          this.flightPlanService.flightPlanningAccordionOpenStatus = undefined;
          this.events.subscribe('etopOnInput', (payloadInput) => {
            if (payloadInput) {
              this.customhContentHeight = true;
            }
          });
          if (!this.flightPlanService.flightPlanningAccordionOpenStatus) {
            this.dockerOption.drawerState = 0;
          }
        }
        if (
          this.flightPlanService.flightPlanningAccordionOpenStatus ==
          'flightdetails'
        ) {
          this.flightPlanService.flightPlanningAccordionOpenStatus = undefined;
          if (!this.flightPlanService.flightPlanningAccordionOpenStatus) {
            this.dockerOption.drawerState = 0;
          }
        }
        if (
          this.flightPlanService.flightPlanningAccordionOpenStatus ==
          'destroute'
        ) {
          this.flightPlanService.flightPlanningAccordionOpenStatus = undefined;
          if (!this.flightPlanService.flightPlanningAccordionOpenStatus) {
            this.dockerOption.drawerState = 0;
          }
        }
        if (
          this.flightPlanService.flightPlanningAccordionOpenStatus ==
          'flightplanfuel'
        ) {
          this.flightPlanService.flightPlanningAccordionOpenStatus = undefined;
          if (!this.flightPlanService.flightPlanningAccordionOpenStatus) {
            this.dockerOption.drawerState = 0;
          }
        }
        if (
          this.flightPlanService.flightPlanningAccordionOpenStatus ==
          'flightplanavoid'
        ) {
          this.flightPlanService.flightPlanningAccordionOpenStatus = undefined;
          if (!this.flightPlanService.flightPlanningAccordionOpenStatus) {
            this.dockerOption.drawerState = 0;
          }
        }
        break;
      default:
        this.dockerOption.drawerState = 1;
        this.drawerDefault = true;
        break;
    }
  }
  public changeIonBottomDrawerHeight(event) {
    if (event == 1) {
      this.customhContentHeight = true;
    } else {
      this.customhContentHeight = false;
    }
  }
  public segmentChanged($event) {}
  public downloadFlightPlan() {
    this.flightPlanService.downloadFlightPlan();
  }
  public close(): void {
    this.event.publish('fetchUpdatedFlightPlans', true);
    if (this.enterTripDetailsService.pageType == 'activityCard') {
      this.enterTripDetailsService.close();
    } else {
      this.location.back();
    }
  }

  public compute() {
    this.flightPlanService
      .compute(this.legId, this.tripID, this.sector,this.selectedRoute == 1 ?environment.firebase_config.projectId == "avplat-local" ? 'testFlight':'production':'')
      .then(() => {});
  }
  public async cancel() {
    try {
      await this.flightPlanService.cancel().then(()=> {
        this.location.back();
      })
    } catch(error) {
      this.commonService.dismissLoader();
    }
  }
  public confirm() {
    this.flightPlanService
      .submitFlightPlan(
        this.legId,
        this.tripID,
        this.sector,
        this.vendorid,
        this.filePath
      )
      .then((data: any) => {
        this.vendorid != undefined ? this.close(): this.location.back();
      });
  }
  public back() {
    this.navCtrl.back();
  }
  public async showWarnings() {
    const warningModal = this.modalCntrl.create({
      component: FlightPlanWarningsComponent,
      componentProps: {
        warnings: this.flightPlanService.tripRouteData?.warnings,
      },
    });
    (await warningModal).present();
  }
}
